import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import { actionTypes, useStateValue } from "../../../store";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { useCookies } from "react-cookie";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LeftMenuHeader from "../../BaseComponents/LeftMenuHeader";
import BadgeIcon from "@mui/icons-material/Badge";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CartIcon from "../../../assets/icons/CartIcon";
import CancelIcon from "@mui/icons-material/Cancel";
import UserIcon from "../../../assets/icons/UserIcon";
import CartIconsm from "../../../assets/icons/CartIconsm";
import UserIconsm from "../../../assets/icons/UserIconsm";
import HeaderSearchCel from "../../BaseComponents/HeaderSearchCel";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import MiniCartSidebar from "../../Cart/MiniCartSidebar";
import ReceiptIcon from "@mui/icons-material/Receipt";
import WishListCel from "../../BaseComponents/WishListCel";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import WidgetsIcon from '@mui/icons-material/Widgets';
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  getProductList,
  hondaLogo,
  logoutcustomer,
  maringLogo,
  hiLogo,
  hiValuePlusLogo,
} from "../../../networkCalls";
import { Autocomplete, TextField } from "@mui/material";
import BtnCompare from "../../Product/BtnCompare";

const Header = () => {
  const [
    {
      token,
      compareitemcount,
      huid,
      loginmodal,
      cartminisidebar,
      cartitemcount,
    },
    dispatch,
  ] = useStateValue();
  const [cookie, setCookie, removeCookie] = useCookies([
    "jwt",
    "huid",
    "hdetial",
  ]);
  const { hdetial } = cookie;

  const isMarinelogo = document.getElementById("marine-outboard-motor");
  const isHiLogo = document.getElementById("hi-product-theme");

  if (isMarinelogo) {
    var logoHeader = maringLogo;
    var maxLogoWidth = "165px";
    var maxLogoWidthMobile = "140px";
    var marginLogoLeft = "w-100";
  } else if (isHiLogo) {
    var logoHeader = hiLogo;
    var maxLogoWidth = "98px";
    var maxLogoWidthMobile = "98px";
    var marginLogoLeft = "ms-2 w-100";
  } else {
    var logoHeader = hondaLogo;
    var maxLogoWidth = "200px";
    var maxLogoWidthMobile = "240px";
    var marginLogoLeft = "ms-2 mb-2 w-100";
  }

  const location = useLocation();
  const navigate = useNavigate();
  const [minicartItem] = useState(
    JSON.parse(localStorage.getItem("h_ct")) || []
  );
  useEffect(() => {
    dispatch({
      type: actionTypes.SET_MINICARTITEM,
      value: minicartItem.length,
    });
  }, [minicartItem]);
  useEffect(() => {
    const setCompareitemcount = () => {
      var existingEntries = JSON.parse(localStorage.getItem("allEntries"));
      dispatch({
        type: actionTypes.SET_COMPAREITEMCOUNT,
        value: existingEntries?.length,
      });
    };
    if (compareitemcount === null) {
      setCompareitemcount();
    }
  }, [compareitemcount]);

  // use for add more product in compare
  const [selectedComProduct, setSelectedComProduct] = React.useState([]);
  const modalHandle = (e, value) => {
    setSelectedComProduct(value);
  };
  const [productData, setProductData] = useState([]);
  const callApiProductData = (value) => {
    var data = new FormData();
    data.append("categoryId", value);
    data.append("all", "true");
    getProductList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setProductData(res.data?.ProductList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  // use for add more product in compare
  const [compareData, setCompareData] = useState(
    JSON.parse(localStorage.getItem("allEntries"))
  );
  const [state, setState] = React.useState({
    left: false,
    right: false,
    bottom: false,
    cartdisplay: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
    if (anchor === "bottom") {
      setCompareData(JSON.parse(localStorage.getItem("allEntries")));
      callApiProductData(compareData && compareData?.[0]?.catid);
    }
  };
  const refreshCompare = () => {
    setCompareData(JSON.parse(localStorage.getItem("allEntries")));
  };

  const removeCompare = (value) => {
    var removeCompare = JSON.parse(localStorage.getItem("allEntries"));
    removeCompare.splice(value, 1);
    localStorage.setItem("allEntries", JSON.stringify(removeCompare));
    setCompareData(JSON.parse(localStorage.getItem("allEntries")));
    dispatch({
      type: actionTypes.SET_COMPAREITEMCOUNT,
      value: removeCompare.length,
    });
  };
  const removeAllCompareData = () => {
    localStorage.removeItem("allEntries");
    dispatch({ type: actionTypes.SET_COMPAREITEMCOUNT, value: "" });
    // toggleDrawer('bottom', false)
    setState({ ...state, bottom: false });
  };
  const btnmyaccount = () => {
    console.log("clicked !!!!")
    dispatch({ type: actionTypes.SET_LOGINMODAL, value: true });
  };

  const logout = () => {
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    logoutcustomer(data).then((res) => {
      switch (res.data.status) {
        case 1:
          removeCookie("jwt", { path: "/" });
          removeCookie("huid", { path: "/" });
          removeCookie("hdetial", { path: "/" });
          dispatch({ type: actionTypes.SET_TOKEN, value: null });
          dispatch({ type: actionTypes.SET_HUID, value: null });
          dispatch({ type: actionTypes.SET_WISHLISTCOUNT, value: "0" });
          dispatch({ type: actionTypes.SET_WISHLISTALLID, value: null });
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: false });
          window.location.href = "/";
          return true;
        case 0:
          dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "error" });
          dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
          dispatch({ type: actionTypes.SET_MSGALERT, value: true });
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };

  const gotoComparePage = () => {
    navigate("/compare/", { state: { id: compareData?.map((t) => t.id) } });
  };

  const gotoCheckout = () => {
    if (!token) {
      setState({ ...state, cartdisplay: false });
      dispatch({ type: actionTypes.SET_LOGINMODAL, value: true });
    } else {
      navigate("/checkout");
    }
  };

  const closeMiniCart = () => {
    setState({ ...state, cartdisplay: false });
    dispatch({ type: actionTypes.SET_MINICART, value: false });
  };

  useEffect(() => {
    if (cartminisidebar === true) {
      setState({ ...state, cartdisplay: true });
    }
  }, [cartminisidebar]);

  // console.log('cartminisidebar', cartminisidebar)

  const list = (anchor) => (
    <Box
      sx={{ width: 300 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="flex items-center justify-between px-4 py-4 border-b bgred">
        <div className="text-blueGray-700 font-semibold text-uppercase text-white fw-bold">
          My Account
        </div>
        <div></div>
      </div>
      {token ? (
        <>
          <List>
            <Link to="/myaccount/dashboard">
              <ListItem button>
                <ListItemIcon>
                  <BadgeIcon />
                </ListItemIcon>
                <ListItemText className="text-black" primary="My Profile" />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <Link to="/myaccount/manage-orders">
              <ListItem button>
                <ListItemIcon>
                  <LocalMallIcon />
                </ListItemIcon>
                <ListItemText className="text-black" primary="My Orders" />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <Link to="/myaccount/manage-addresses">
              <ListItem button>
                <ListItemIcon>
                  <AddLocationAltIcon />
                </ListItemIcon>
                <ListItemText
                  className="text-black"
                  primary="Delivery Addresses"
                />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <Link to="/myaccount/billing-addresses">
              <ListItem button>
                <ListItemIcon>
                  <ReceiptIcon />
                </ListItemIcon>
                <ListItemText
                  className="text-black"
                  primary="Billing Addresses"
                />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <Link to="/myaccount/manage-wishlist">
              <ListItem button>
                <ListItemIcon>
                  <FavoriteBorderIcon />
                </ListItemIcon>
                <ListItemText className="text-black" primary="My Wishlist" />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <Link to="/myaccount/sell-your-product">
              <ListItem button>
                <ListItemIcon>
                  <WidgetsIcon />
                </ListItemIcon>
                <ListItemText className="text-black" primary="Sell your Product" />
              </ListItem>
            </Link>
          </List>
          <List>
            <Link to="/myaccount/product-enquiries">
              <ListItem button>
                <ListItemIcon>
                  <LocalMallIcon />
                </ListItemIcon>
                <ListItemText className="text-black" primary="My Product Enquiries" />
              </ListItem>
            </Link>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={logout}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText className="text-black" primary="Logout" />
            </ListItem>
          </List>
        </>
      ) : (
        <List>
          <ListItem button onClick={btnmyaccount}>
            <ListItemIcon>
              <UserIconsm />
            </ListItemIcon>
            <ListItemText primary="Login" />
          </ListItem>
        </List>
      )}
    </Box>
  );

  const leftMenu = (anchor) => (
    <Box
      sx={{ width: { xs: 320, sm: 320 } }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
      className="mobile-left-nav"
    >
      <LeftMenuHeader />
    </Box>
  );

  const cartdisplay = (anchor) => (
    <Box
      sx={{ width: { xs: 300, sm: 500 } }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
      className="bglblue"
    >
      <div className="d-flex flex-column vh-100">
        <div className="d-flex align-items-center justify-content-between border-b bgred">
          <div className="d-flex  align-items-center ms-2">
            <IconButton size="large" color="inherit">
              <Badge
                badgeContent={`${cartitemcount ? cartitemcount : 0}`}
                color="info"
                className="mt-1"
              >
                <CartIcon />
              </Badge>
            </IconButton>
            <div className="ms-2 text-white fw-bold">MY CART</div>
          </div>
          <div className="btn btn-sm bg-white me-2">
            <CloseIcon onClick={() => closeMiniCart()} />
          </div>
        </div>
        <div className="bglblue">
          {cartitemcount && cartitemcount > 0 ? (
            <>
              <MiniCartSidebar />
            </>
          ) : (
            <>
              <div className="d-flex row text-center fw-bold f20 vh-100 align-items-center">
                <div className="col-12">No item in your cart</div>
              </div>
            </>
          )}
        </div>
        <div className="mt-md-auto btn-cart-finalmob">
          {" "}
          {cartitemcount && cartitemcount > 0 ? (
            <>
              {/* <div className='bgdgray p-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='f18 fw-bold text-white'>Grand Total</div>
                            <div className='f18 fw-bold text-white'><CurrencyRupeeIcon className='f14 text-white' />323,343</div>
                        </div>
                    </div> */}
              <div className="bgdgray p-3 pt-0">
                <div className="row align-items-center">
                  <div className="col-12 pt-3">
                    <Button
                      color="error"
                      onClick={() => gotoCheckout()}
                      variant="contained"
                      className="w-100"
                      type="submit"
                    >
                      GO TO CHECKOUT
                    </Button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </Box>
  );

  const comparePop = (anchor) => (
    <Box
      sx={{ width: "auto" }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
      className=""
    >
      <div className="container">
        <div className="row mt-3 mb-3">
          <div className="col-md-9 col-8">
            <div className="row">
              {compareData &&
                compareData?.map((data, i) => (
                  <div key={i} className="col-md-3 col-6 mb-2">
                    <div className="card p-2 text-center position-relative">
                      <IconButton
                        onClick={() => {
                          removeCompare(i);
                        }}
                        size="small"
                        className="position-absolute text-white"
                        style={{ right: "0px", top: "0px" }}
                      >
                        <CancelIcon className="txtred" />
                      </IconButton>
                      <div className="">
                        <div className="p_img">
                          <img
                            src={data?.img}
                            alt=""
                            className="img-fluid"
                            style={{ maxWidth: "80px" }}
                          />
                        </div>
                        <div className="mt-2">{data?.title}</div>
                      </div>
                    </div>
                  </div>
                ))}
              {compareData && compareData?.length < 4 ? (
                <>
                  <div className="col-md-3 col-6 mb-2">
                    <div className="fw-bold pt-2">Add a product</div>
                    <Autocomplete
                      disablePortal
                      id="modal"
                      className="mb-3"
                      name="modal"
                      getOptionLabel={(option) => option.name}
                      options={productData}
                      // defaultValue={}
                      onChange={modalHandle}
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          {...params}
                          required
                          label="Select Model"
                        />
                      )}
                    />
                    {selectedComProduct && selectedComProduct?.productId > 0 ? (
                      <>
                        {" "}
                        <div className="" onClick={refreshCompare}>
                          <BtnCompare
                            pid={selectedComProduct?.productId}
                            catid={selectedComProduct?.mainCatId}
                            btntype={"withlbl"}
                            pname={selectedComProduct?.name}
                            entryText={selectedComProduct?.shortDescription}
                            pimage={selectedComProduct?.image}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-3 col-4">
            {compareitemcount > 1 ? (
              <>
                <Button
                  variant="contained"
                  onClick={gotoComparePage}
                  size="small"
                  className="d-block w-100"
                >
                  COMPARE{" "}
                  <span className="d-none d-md-inline-block ms-2 bg-white text-primary  border rounded ps-1 pe-1">
                    {compareitemcount}
                  </span>
                </Button>
              </>
            ) : null}
            <Button
              variant="outlined"
              onClick={removeAllCompareData}
              size="small"
              className="d-block mt-4 w-100"
            >
              Clear all
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );

  return (
    <>
      {compareitemcount &&
      compareitemcount > 0 &&
      location.pathname != "/compare/" ? (
        <>
          <div
            className="position-fixed p-4"
            style={{
              zIndex: 100,
              right: "10px",
              bottom: "10px",
              fontSize: "34px",
            }}
          >
            <Button
              variant="contained"
              onClick={toggleDrawer("bottom", true)}
              size="large"
            >
              COMPARE{" "}
              <span className="ms-2 bg-white text-primary d-inline-block border rounded ps-1 pe-1">
                {compareitemcount}
              </span>
            </Button>
          </div>
        </>
      ) : null}

      <div className="site site--desktop-header--spaceship-one site--mobile-header--mobile-one">
        <header className="site__header d-none d-lg-block  px-5 mx-5 py-2">
          <div className="d-flex justify-content-between">
          
            <div className="header__navbar align-items-center d-flex">
              {/* <LeftMenuHeader /> */}
              <div
                className="d-flex align-items-center ms-2"
                onClick={toggleDrawer("left", true)}
              >
                <IconButton size="large" color="inherit">
                  <div className="menu_icon">
                    <MenuIcon className="txtred" />
                  </div>
                </IconButton>
                <div className="text-start">
                  <span className="indicator__value d-block f16 fw-bold">
                    MENU
                  </span>
                </div>
              </div>
            </div>
            <div className=" d-flex align-items-center">
              <Link className="logo" to="/hi-value-plus">
                <div className="logo__image text-center">
                  {/* <img className='' src={"https://www.hondacarindia.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.5841d9c0.png&w=3840&q=75"} style={{ maxWidth: "400px" }} alt="honda" /> */}
                  <img
                    className="mt-1"
                    src={hiValuePlusLogo}
                    style={{ maxWidth: "180px" }}
                    alt="honda"
                  />
                </div>
                <div className=" txtlgeay text-uppercase f12 ps-4 pe-4 pb-3">
                  {/* India's No. 1 Power Products company */}
                </div>
              </Link>
            </div>
            <div className="header__indicators">

              <div
                className="d-flex align-items-center ms-2"
                onClick={!token ? btnmyaccount : toggleDrawer("right", true)}
              >
                <IconButton size="large" color="inherit">
                  <div>
                    {" "}
                    <UserIcon />
                  </div>
                </IconButton>
                <div className="text-start">
                  {token ? (
                    <>
                      <span className="indicator__title d-block f12">
                        Hello, {hdetial}
                      </span>
                      <span className="indicator__value d-block f16 fw-bold">
                        My Account
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="indicator__title d-block f12">
                        Hello Guest
                      </span>
                      <span className="indicator__value d-block f16 fw-bold">
                        Log In
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* toggleDrawer('bottom', true); */}

        {/* for mobile */}
        <Box sx={{ flexGrow: 1 }} className="d-lg-none mobile-app-header">
          <AppBar position="static" className="bg-white pt-1 pb-2">
            <Toolbar className="d-flex justify-content-between align-items-center">
              <IconButton
                onClick={toggleDrawer("left", true)}
                size="medium"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ mr: 0 }}
              >
                <MenuIcon className="txtred" />
              </IconButton>
              <Link to="/hi-value-plus">
                 <img
                  src={hiValuePlusLogo}
                  alt="honda"
                  style={{ maxWidth: maxLogoWidthMobile }}
                  className={"w-lg-100 logomobilehivalue"}
                />
              </Link>
              {/* <Box sx={{ flexGrow: 1 }} /> */}
              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                
                <IconButton
                  onClick={!token ? btnmyaccount : toggleDrawer("right", true)}
                  size="large"
                  edge="end"
                  aria-haspopup="true"
                  color="inherit"
                >
                  <UserIconsm />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
        </Box>
        <React.Fragment key="left">
          <Drawer
            anchor="left"
            open={state["left"]}
            onClose={toggleDrawer("left", false)}
          >
            {leftMenu("left")}
          </Drawer>
        </React.Fragment>
        <React.Fragment key="right">
          <Drawer
            anchor="right"
            open={state["right"]}
            onClose={toggleDrawer("right", false)}
          >
            {list("right")}
          </Drawer>
        </React.Fragment>
        <React.Fragment key="bottom">
          <Drawer
            anchor="bottom"
            open={state["bottom"]}
            onClose={toggleDrawer("bottom", false)}
          >
            {comparePop("bottom")}
          </Drawer>
        </React.Fragment>

        {/* for mobile */}
        <React.Fragment key="cartdisplay">
          <Drawer
            anchor="right"
            open={state["cartdisplay"]}
            onClose={toggleDrawer("cartdisplay", false)}
          >
            {cartdisplay("right")}
          </Drawer>
        </React.Fragment>
      </div>
    </>
  );
};

export default Header;
